import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaStudentData } from "@/src/types/admissionOffice";

const AOPMaltaStudentLayout = () => {
  const [customize, setCustomize] = useState<boolean>(false);

  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaStudentData>({
    currentDate: "",
    fullName: "",
    dateOfBirth: "",
    nationality: "",
    course: "",
    userOffice: "01",
    whose_doc: "",
    title: "",
    duration: "",
    mediumOfInstruction: "",
    passportNumber: "",
    academicYear: "",
    yearOfStudy: "",
    yearStudyMode: "",
    coursePrefix: "",
    bodyStudentLetter: [],
    secondBodyStudentLetter: null,
    secondPageDate: "",
    thirdBodyStudentLetter: null,
    file: null,
  });

  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaStudentData>({
    currentDate: "",
    fullName: "",
    dateOfBirth: "",
    nationality: "",
    course: "",
    userOffice: "01",
    whose_doc: "",
    title: "",
    duration: "",
    mediumOfInstruction: "",
    passportNumber: "",
    academicYear: "",
    yearOfStudy: "",
    yearStudyMode: "",
    coursePrefix: "",
    bodyStudentLetter: [],
    secondBodyStudentLetter: null,
    secondPageDate: "",
    thirdBodyStudentLetter: null,
    file: null,
  });

  return (
    <>
      <div className="container admission-office-page">
        <AOPConfig
          dataForGeneration={dataForGeneration}
          setDataForGeneration={setDataForGeneration}
          setBodyForPrev={setBodyForPrev}
          setCustomize={setCustomize}
        />
        <AOPPrev bodyForPrev={bodyForPrev} customize={customize} />
      </div>
    </>
  );
};

export default AOPMaltaStudentLayout;
